<template>
  <div class="dashboard-container">
    <h2>数据统计</h2>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
        <el-card class="box-card" shadow="hover">
          <div class="item">
            <p>平台利润</p>
            <p>{{ getInfo.platformProfitAmount }}</p>
            <p>昨日:{{ getInfo.yesterdayPlatformProfitAmount }}</p>
            <el-divider />
            <p>总利润</p>
            <p>{{ getInfo.totalProfitAmount }}</p>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
        <el-card class="box-card" shadow="hover">
          <div class="item">
            <p>今日会员数</p>
            <p>{{ getInfo.todayRegisterUserCount }}</p>
            <p>昨日:{{ getInfo.yesterdayNewUserCount }}</p>
            <el-divider />
            <p>会员总数</p>
            <p>{{ getInfo.userTotalCount }}</p>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
        <el-card class="box-card" shadow="hover">
          <div class="item">
            <p>今日提现（金额）</p>
            <p>{{ getInfo.todayWithdrawTotalAmount }}（笔数：{{ getInfo.todayWithdrawOrderCount }}）</p>
            <p>昨日:{{ getInfo.yesterdayWithdrawOrderCount }}（笔数：{{ getInfo.yesterdayWithdrawOrderCount }}）</p>
            <el-divider />
            <p>总提现（金额）</p>
            <p>{{ getInfo.withdrawTotalAmount }}（笔数：{{ getInfo.withdrawTotalOrderCount }}）</p>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
        <el-card class="box-card" shadow="hover">
          <div class="item">
            <p>今日提现（U）</p>
            <p>无（笔数：无）</p>
            <p>昨日:无（笔数：无）</p>
            <el-divider />
            <p>总提现（金额）</p>
            <p>无（笔数：无）</p>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
        <el-card class="box-card" shadow="hover">
          <div class="item">
            <p>今日充值</p>
            <p>{{ getInfo.todayRechargeTotalAmount }}（笔数：{{ getInfo.todayRechargeOrderCount }}）</p>
            <p>昨日:{{ getInfo.yesterdayRechargeOrderCount }}（笔数：{{ getInfo.yesterdayRechargeOrderCount }}）</p>
            <el-divider />
            <p>总充值（金额）</p>
            <p>{{ getInfo.rechargeTotalAmount }}（笔数：{{ getInfo.todayRechargeOrderCount }}）</p>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
        <el-card class="box-card" shadow="hover">
          <div class="item">
            <p>今日充值(U)</p>
            <p>无（笔数：无）</p>
            <p>昨日:无（笔数：无）</p>
            <el-divider />
            <p>总充值（U）</p>
            <p>无（笔数：无）</p>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
        <el-card class="box-card" shadow="hover">
          <div class="item">
            <p>今日充值人数</p>
            <p>{{ getInfo.todayNewUserCount }}</p>
            <p>昨日:{{ getInfo.yesterdayNewUserCount }}</p>
            <el-divider />
            <p>充值总人数</p>
            <p>{{ getInfo.rechargeUserCount }}</p>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
        <el-card class="box-card" shadow="hover">
          <div class="item">
            <p>充值手续费</p>
            <p>{{ getInfo.rechargeFeeAmount }}</p>

            <el-divider />
            <p>提现手续费</p>
            <p>{{ getInfo.withdrawFeeAmount }}</p>
          </div>
        </el-card>
      </el-col>

    </el-row>
    <el-row :gutter="20">
      <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
        <el-card class="box-card" shadow="hover">
          <div class="item">
            <p>用户资金余额</p>
            <p>{{ getInfo.userAssetsTotalBalance }}</p>

            <el-divider />
            <p>投资总额</p>
            <p>{{ getInfo.investTotalAmount }}</p>
          </div>
        </el-card>
      </el-col>

    </el-row>
  </div>
</template>

<script>
import { get, post } from '@/utils/request'

export default {
  name: 'Dashboard',

  data() {
    return {
      getInfo: {}
    }
  },
  computed: {},
  created() {
    this.getInfoList()
  },
  methods: {
    getInfoList() {
      get('/admin/data/dashboard').then((res) => {
        this.getInfo = res.data
      })
    }
  }
}
</script>
<style lang="scss" scope>
.el-col {
  margin-bottom: 20px;
}
.el-card__body {
  min-height: 205px;
}
.item {
  p {
    margin: 5px;
  }
}
</style>
